export default function maybeIPad(deviceInfo) {
  const touchDevice =
    typeof document !== "undefined" && "ontouchend" in document;
  return touchDevice && deviceInfo?.isMac;
}
